/**
 * API configuration
 */

// Base URL for the backend API
// export const JWT_HOST_API = "https://crmapi.sensationsolutions.in/";
// export const JWT_HOST_API = "https://localhost:44371/";
// export const JWT_HOST_API = "http://localhost:5096/";
// export const JWT_HOST_API = "https://api.sensationcrm.com/";
// export const JWT_HOST_API = "https://crmapi.pcte.edu.in/";
export const JWT_HOST_API = import.meta.env.VITE_JWT_HOST_API;

// Static keys for auth headers (replace with env/secure storage in real use)
export const API_KEY = import.meta.env.VITE_API_KEY;
export const API_SECRET_KEY = import.meta.env.VITE_API_SECRET_KEY;
export const AES_SECRET_KEY = import.meta.env.VITE_AES_SECRET_KEY;


// -------------FIREBASE AUTH CONFIGURATION----------------
export const VAPID_KEY = import.meta.env.VITE_VAPID_KEY;
export const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;

// Development-only fallback to allow login without a backend token.
// Configure via Vite env vars: VITE_AUTH_DEV_FALLBACK and VITE_AUTH_DEV_TOKEN_TTL_MIN
export const AUTH_DEV_FALLBACK =
  typeof import.meta !== "undefined" &&
    import.meta.env &&
    typeof import.meta.env.VITE_AUTH_DEV_FALLBACK !== "undefined"
    ? String(import.meta.env.VITE_AUTH_DEV_FALLBACK).toLowerCase() === "true"
    : false;

export const AUTH_DEV_TOKEN_TTL_MIN =
  typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_AUTH_DEV_TOKEN_TTL_MIN
    ? Number(import.meta.env.VITE_AUTH_DEV_TOKEN_TTL_MIN) || 5
    : 5;
